import { useState } from 'react';
import './App.css';
import ChatbotPage from './modules/chatbox/ChatboxPage';
import LoginPage from './modules/login/LoginPage';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  return (
    <div className="App">
      {isLoggedIn ? <ChatbotPage handleLogout={setIsLoggedIn} /> : <LoginPage handleLogin={setIsLoggedIn} />}
    </div>
  );
}

export default App;
